import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useOurGames } from 'services/module/games'
import { setGamesData, setGamesLoading } from './actions'

export default function GamesUpdater(): null {
  const dispatch = useDispatch()
  const { loading, games } = useOurGames()
  useEffect(() => {
    dispatch(setGamesData(games))
    dispatch(setGamesLoading(loading))
  }, [dispatch, games, loading])

  return null
}
